<template>
    <div>
        <div class="w-100 h-100 d-flex flex-column">
            <div class="w-100 bg-light" v-if="orderWidgetData">
                <b-link :href="$urlHelper.getPageUrl('OrderRequests')" class="btn border-info w-100">
                    <span class="text-secondary">Total orders: </span> {{ orderWidgetData.totalClientOrders }}
                </b-link>
            </div>

            <div ref="chartWrapper" class="flex-grow-1 overflow-hidden">
                <ejs-accumulationchart :id="'chart_'+dashboardWidgetConfigurationId"
                                       :theme='theme'
                                       align='center'
                                       :height="chartHeight"
                                       :width="chartWidth"
                                       :legendSettings='legendSettings'
                                       :tooltip='tooltip'
                                       :enableAnimation='false'
                                       :enableBorderOnMouseMove='false'
                                       :annotations='annotations'
                                       v-if="chartDataLoaded && seriesData.length">
                    <e-accumulation-series-collection class="pt-0 mt-0" id="b">
                        <e-accumulation-series :dataSource='seriesData' :innerRadius='innerRadius' tooltipMappingName='tooltipMappingName' :radius='radius' :startAngle='startAngle' fill="fill"
                                               :endAngle='endAngle' xName='x' yName='y' :dataLabel='dataLabel' :pointColorMapping='pointColorMapping'> </e-accumulation-series>
                    </e-accumulation-series-collection>
                </ejs-accumulationchart>
                <div v-else>-- no relevant data found --</div>
            </div>
        </div>
        <b-modal v-model="modalVisible" title="Settings" @ok="handleModalOk" size="md">
            <b-form-group label="Title" label-for="widgetTitle">
                <b-form-input name="widgetTitle" v-model="widgetTitle"></b-form-input>
            </b-form-group>

            <b-form-group label="Court/Tribunal/Other"
                          label-for="courtRegistryId">
                <select2 name="courtRegistryId"
                         :options="allCourtRegistries"
                         multiple
                         key-property="courtRegistryId"
                         text-property="name"
                         v-model="currentConfiguration.courtRegistryIds">
                </select2>
            </b-form-group>
            <b-form-group label="Organisation"
                          label-for="interviewOrganisatoinId">
                <select2 name="interviewOrganisatoinId"
                         :options="allInterviewOrganisations"
                         multiple
                         key-property="interviewOrganisationId"
                         text-property="name"
                         v-model="currentConfiguration.interviewOrganisationIds">
                </select2>
            </b-form-group>
            <b-form-group label="Jurisdiction"
                          label-for="courtJurisdictionId">
                <select2 name="courtJurisdictionId"
                         :options="allCourtJurisdictions"
                         multiple
                         key-property="courtJurisdictionId"
                         text-property="name"
                         v-model="currentConfiguration.courtJurisdictionIds">
                </select2>
            </b-form-group>
            <b-form-group label="Service Type"
                          label-for="serviceTypeId">
                <select2 name="serviceTypeId"
                         :options="allServiceTypes"
                         multiple
                         key-property="serviceTypeId"
                         text-property="name"
                         v-model="currentConfiguration.serviceTypeIds">
                </select2>
            </b-form-group>
            <b-form-group label="Turn around"
                          label-for="serviceDelayId">
                <select2 name="courtJurisdictionId"
                         :options="allServiceDelays"
                         multiple
                         key-property="serviceDelayId"
                         text-property="name"
                         v-model="currentConfiguration.serviceDelayIds">
                </select2>
            </b-form-group>
        </b-modal>
    </div>
</template>


<script>
    import { Browser } from '@syncfusion/ej2-base';
    import Vue from 'vue';
    import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, AccumulationTooltip, PieSeries, AccumulationDataLabel, AccumulationLegend, ChartAnnotation } from "@syncfusion/ej2-vue-charts";
    // my iport strt
    import axios from 'axios';
    import BootstrapVue from 'bootstrap-vue';
    import Visibility from 'visibilityjs';
    import ErrorsMixin from '../../../mixins/ErrorsMixin';
    import Select2 from '../../Select2';
    Vue.use(BootstrapVue);
    Vue.component('select2', Select2);
    let selectedTheme = location.hash.split("/")[1];
    selectedTheme = selectedTheme ? selectedTheme : "Material";
    let theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark").replace(/contrast/i, 'Contrast');

    export default {
        components: {
            'ejs-accumulationchart': AccumulationChartComponent,
            'e-accumulation-series-collection': AccumulationSeriesCollectionDirective,
            'e-accumulation-series': AccumulationSeriesDirective
        },
        name: 'ClientOrdersWidget',
        mixins: [ErrorsMixin],
        props: {
            dashboardWidgetConfigurationId: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            configuration: {
                type: Object,
                default: null
            },
            widgetMode: {
                type: String,
                default: 'view'
            },
            selectedTimeRange: {
                type: Number,
                required: true
            }
        },
        data: function () {
            return {

                orderWidgetData: null,
                timer: null,
                refreshIntervalInMilliseconds: 60000,
                modalVisible: false,
                widgetTitle: this.title,
                currentConfiguration: this.configuration ? this.configuration : { courtRegistryIds: null, interviewOrganisationIds: null, courtJurisdictionIds: null, serviceTypeIds: null, serviceDelayIds: null },
                allCourtRegistries: null,
                allInterviewOrganisations: null,
                allCourtJurisdictions: null,
                allServiceTypes: null,
                allServiceDelays: null,
                legendSettings: { visible: false },

                pointColorMapping: 'fill',
                tooltip: {
                    enable: true, header: '<b>${point.x}</b>', format: '<b>${point.y} Orders</b>'
                },
                enableAnimation: true,
                enableSmartLabels: true,
                seriesData: [],
                chartDataLoaded: false,
                
                theme: theme,
                dataLabel: {
                    visible: true, position: 'Inside', enableRotation: true,
                    connectorStyle: { length: '20px', type: 'Curve' }, name: 'text',
                    font: { fontFamily: 'Segoe UI', fontWeight: '400', size: Browser.isDevice ? '8px' : '12px', color: "#ffffff" }
                },

                startAngle: 270, endAngle: 90,

                innerRadius: '40%',
                radius: Browser.isDevice ? '85%' : '100%',
                annotations: [{
                    content: '<div style="font-size:14px; font-weight:600">Order<br>Distribution</div>',
                    region: 'Series',
                    x: "50%",
                    y: "88%"
                }],

                resizeObserver: null,
                chartHeight: '',
                chartWidth: '',
            };
        },
        provide: {
            accumulationchart: [AccumulationLegend, PieSeries, AccumulationDataLabel, AccumulationTooltip, ChartAnnotation]
        },
        watch: {
            selectedTimeRange: function () {
                this.reloadData();
            }
        },
   
        methods: {

            handleModalOk() {
                this.modalVisible = false;
                this.$emit('configurationChanged', this.widgetTitle, this.currentConfiguration);
            },
            loadData: function () {
                if (this.dashboardWidgetConfigurationId) {
                    var url = this.$urlHelper.getApiUrl('dashboardwidget', 'data', ['clientorders', this.dashboardWidgetConfigurationId, this.selectedTimeRange]);
                    axios
                        .get(url)
                        .then(response => {

                            this.orderWidgetData = response.data;
                            this.seriesData = [];
                            var obj = {};

                            if (response.data.unSubmitted) {
                                obj = {};
                                obj.x = 'unsubmitted';
                                obj.y = response.data.unSubmitted;
                                obj.fill = '#CCCCCC';
                                obj.text = response.data.unSubmitted + ' unsubmitted';
                                this.seriesData.push(obj);
                            }
                            if (response.data.submitted) {
                                obj = {};
                                obj.x = 'submitted';
                                obj.y = response.data.submitted;
                                obj.fill = '#90EE90';
                                obj.text = response.data.submitted + ' submitted';
                                this.seriesData.push(obj);
                            }
                            if (response.data.inProgress) {
                                obj = {};
                                obj.x = 'in progress';
                                obj.y = response.data.inProgress;
                                obj.fill = '#32CD32';
                                obj.text = response.data.inProgress + ' in progress';
                                this.seriesData.push(obj);
                            }
                            if (response.data.completed) {
                                obj = {};
                                obj.x = 'completed';
                                obj.y = response.data.completed;
                                obj.fill = 'green';
                                obj.text = response.data.completed + ' completed';
                                this.seriesData.push(obj);
                            }
                            if (response.data.cancelled) {
                                obj = {};
                                obj.x = 'cancelled';
                                obj.y = response.data.cancelled;
                                obj.fill = 'red';
                                obj.text = response.data.cancelled + ' cancelled';
                                this.seriesData.push(obj);
                            }
                            this.chartDataLoaded = false;

                            this.$nextTick(() => {
                                this.chartDataLoaded = true;
                            });
                            
                        })
                        .catch(ex => {
                            console.log(JSON.stringify(ex));
                            var currentErrors = this.handleAxiosException(ex);
                            this.showErrorsToast(currentErrors);
                        });
                }
            },

            loadDropDownData: function () {

                var promises = [];
                var url = '';

                url = this.$urlHelper.getApiUrl('courtregistry', 'all');
                promises.push(
                    axios
                        .get(url)
                        .then(response => {
                            this.allCourtRegistries = response.data;

                        })
                )
                url = this.$urlHelper.getApiUrl('intervieworganisation', 'all');
                promises.push(
                    axios
                        .get(url)
                        .then(response => {
                            this.allInterviewOrganisations = response.data;
                        })
                )
                url = this.$urlHelper.getApiUrl('courtjurisdiction', 'all');
                promises.push(
                    axios
                        .get(url)
                        .then(response => {
                            this.allCourtJurisdictions = response.data;

                        })
                )
                url = this.$urlHelper.getApiUrl('servicetype', 'all');
                promises.push(
                    axios
                        .get(url)
                        .then(response => {
                            this.allServiceTypes = response.data;

                        })
                )
                url = this.$urlHelper.getApiUrl('servicedelay', 'all');
                promises.push(
                    axios
                        .get(url)
                        .then(response => {
                            this.allServiceDelays = response.data;

                        })
                )
                Promise
                    .all(promises)
                    .catch(ex => {
                        console.log(JSON.stringify(ex));
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            editConfiguration: function () {
                this.modalVisible = true;
            },

            reloadData: function () {
                if (this.widgetMode == 'view') {
                    this.loadData();
                }
            },

            onResize: function () {
                var chartWrapperSize = this.$refs.chartWrapper.getBoundingClientRect();
                this.chartWidth = Math.trunc(chartWrapperSize.width) + "px";
                this.chartHeight = Math.trunc(chartWrapperSize.height) + "px";
            }
        },

        mounted: function () {
            this.resizeObserver = new ResizeObserver(this.onResize);
            this.resizeObserver.observe(this.$refs.chartWrapper);
            // loads the actual chart data
            this.loadData();
            // loads data for the 4 filter drop downs
            this.loadDropDownData();
            this.timer = Visibility.every(this.refreshIntervalInMilliseconds, this.reloadData);
        },
        beforeDestroy() {
            this.resizeObserver.unobserve(this.$refs.chartWrapper);
        }
    };
</script>